import { RmsBadgeTemplateFormSettings } from '@/backend/features/badging/badging-configuration/types';

export const defaultBadgeFormSettings: RmsBadgeTemplateFormSettings = {
    badgeDocumentName: 'Messachussets Volunteer Program for Public Health (Medical Responder)',
    description:
        'This folder contains badges for Medical Responders in the Massachusetts Volunteer Program for Public Health. Admins can manage and customize these badges here.',
    badgeLabel: 'Health Safety and Environmental Department',
    badgeTitle: 'Emergency Responder',
    defaultExpirationInterval: 24,
    affiliation: 'Volunteer',
    showFullName: true,
    nameOrder: 'firstName',
    showIssuedDate: true,
    showOccupation: true,
    showDateOfBirth: true,
    showBarcode: true,
    showExpirationDate: true,
    disclaimer:
        'This credential is the property of the issuing authority. The bearer of this card is a designated emergency volunteer. After credential verification, the bearer should be granted access to controlled areas. All reasonable efforts, in accordance with federal guidelines for volunteer health professionals, have been made to ascertain the credentials of individuals interested in becoming a volunteer.',
    returnAddress: '1234 Elmwood Avenue, Suite 567, Springfield, CA 90210, USA',
    showHeight: true,
    showHairColor: true,
    showEyeColor: true,
    showAffiliation: true,
    showEcl: true,
    showStateLicenseNumber: true,
};
